module.exports = __webpack_public_path__ + "img/logo_csrc.846a6d38.png";